import SupplierMarketplaceNavigationModal from './SupplierMarketplaceNavigationModal'

export default SupplierMarketplaceNavigationModal
